// extracted by mini-css-extract-plugin
module.exports = {"bkw-J":"J_bkw-J__stHX7"};